/**
 * @file     parseListingsResponse.ts
 * @purpose  Normalize any /api/mls/listings response body into a guaranteed
 *           { count, results } shape. The endpoint can return a non-200 JSON
 *           body (429 rate-limit { error }, 403 bot block, error envelopes)
 *           where `results` is absent — passing that straight into setState
 *           crashes the page on the next `.length`/`.map`. Always route raw
 *           fetch JSON through this before touching it.
 */

import type { ListingCard } from '@/services/mls/mlsPropertyService';

export interface NormalizedListings {
  count: number;
  results: ListingCard[];
}

export function parseListingsResponse(data: unknown): NormalizedListings {
  if (!data || typeof data !== 'object') return { count: 0, results: [] };
  const obj = data as { count?: unknown; results?: unknown };
  const results = Array.isArray(obj.results) ? (obj.results as ListingCard[]) : [];
  const count = typeof obj.count === 'number' ? obj.count : results.length;
  return { count, results };
}
